import connect from 'react-redux/es/connect/connect';
import SignInModal from '../../components/modals/SignInModal';
import { setLoggedInUser } from '../../actions/user';

const mapDispatchToProps = dispatch => ({
    setLoggedInUser: user => {
        dispatch(setLoggedInUser(user));
    }
});

export default connect(() => {
    return {};
}, mapDispatchToProps)(SignInModal);
